import { all } from 'redux-saga/effects';
import runSyncCheckSaga from './runSyncCheckSaga';

export default all([runSyncCheckSaga()]);
